import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import React, { Fragment, useEffect, useState } from "react";
import { Dialog as MUIDialog, DialogContent } from "@mui/material";

import { logo, schema } from "./agentObject";
import { useAxios } from "../../../hooks";
import { AddNewAgentForm } from "./AddNewForm";
import { alert } from "../../../redux/slices/alertSlice";

export default function AddNewAgentDialog({
  setAgents,
  dialogState,
  setDialogState,
  setColumns,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();

  const [fields, setFields] = useState([]);
  const [buttons, setButton] = useState();
  const [channels, setChannels] = useState([]);

  const { activeBrand, accessToken } = useSelector(
    (state) => state.memberDetails
  );

  const cpassAxios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: "Bearer " + accessToken,
  });

  const handleClose = (e, reason) => {
    if (reason && reason === "backdropClick") return;
    setDialogState({ data: {}, state: false });
    setFields([]);
  };

  useEffect(() => {
    axios({
      url: "/get/campaign/preferredChannels?type=add_agent",
      disableError: true,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setChannels(response.data);
      }
    });

    if (dialogState?.update && dialogState.data?.channel_id) {
      cpassAxios({
        url: "/bot/get-agent-fields/" + dialogState.data?.channel_id,
      }).then((response) => {
        if (response.status) {
          setFields(response.data.data);
          setButton(response.data?.pdf);
        }
      });
    }
  }, [axios, cpassAxios, dialogState.data?.channel_id, dialogState?.update]);

  return (
    <React.Fragment>
      <MUIDialog
        open={dialogState.state}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              minWidth: "800px",
            },
          },
        }}
      >
        <DialogContent>
          <Formik
            validationSchema={schema(fields)}
            enableReinitialize
            initialValues={dialogState.data}
            validateOnMount
            onSubmit={async (formData, { setSubmitting, resetForm }) => {
              let tokenValidation = true;
              let token = "";
              if (parseInt(formData.channel_id) === 3) {
                await cpassAxios({
                  url: "/bot/debug-token",
                  method: "POST",
                  data: {
                    access_token: formData.meta_access_token,
                    ad_account_id: formData.meta_ad_account_id,
                  },
                  disableRedirect: true,
                  disableError: true,
                }).then((response) => {
                  if (!response.status) {
                    tokenValidation = false;
                    dispatch(
                      alert({
                        type: "warning",
                        message: response.message?.displayMessage,
                      })
                    );
                    setSubmitting(false);
                    return;
                  } else {
                    token = response.data?.data?.expires_at;
                  }
                });
              }

              if (tokenValidation) {
                cpassAxios({
                  url: "/bot/save-agent",
                  method: "POST",
                  data: {
                    brand_id: activeBrand.ID,
                    ...formData,
                    ...(formData.channel_id === 3 &&
                      token && { expiry_token: token }),
                  },
                  disableRedirect: true,
                })
                  .then(async (res) => {
                    console.log(res);
                    if (res.status) {
                      setAgents((prev) => setAgent(prev));
                      function setAgent(prev) {
                        let prevAgents = [...prev];
                        let agent = prevAgents.filter(
                          (agen) => agen.channelID === formData.channel_id
                        );
                        if (agent.length > 0) {
                          for (let [index, agent] of prevAgents.entries()) {
                            if (agent.channelID === formData.channel_id) {
                              if (dialogState.update) {
                                let currentAgents = [
                                  ...prevAgents[index][res.data.channelName],
                                ];
                                currentAgents[dialogState.index] = res.data;
                                prevAgents[index] = {
                                  ...prevAgents[index],
                                  [res.data.channelName]: [...currentAgents],
                                };
                              }
                              if (dialogState.create) {
                                prevAgents[index] = {
                                  ...prevAgents[index],
                                  [res.data.channelName]: [
                                    ...prevAgents[index][res.data.channelName],
                                    res.data,
                                  ],
                                };
                              }
                            }
                          }
                        } else {
                          getFields(res.data.channel_id);
                          prevAgents.push({
                            channelID: res.data.channel_id,
                            channelLogo: logo[res.data.channelName],
                            channelName: res.data.channelName,
                            [res.data.channelName]: [res.data],
                          });
                        }

                        return prevAgents;
                      }
                      dispatch(
                        alert({
                          type: "success",
                          message: "Agent added successfully",
                        })
                      );
                      handleClose();
                    } else {
                      dispatch(
                        alert({
                          type: "error",
                          message: res?.message,
                        })
                      );
                    }
                    setSubmitting(false);
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              }
            }}
          >
            {(formikProps) => (
              <Fragment>
                <AddNewAgentForm
                  buttons={buttons}
                  setButton={setButton}
                  dialogState={dialogState}
                  fields={fields}
                  setFields={setFields}
                  handleClose={handleClose}
                  formikProps={formikProps}
                  channels={channels}
                />
              </Fragment>
            )}
          </Formik>
        </DialogContent>
      </MUIDialog>
    </React.Fragment>
  );

  function getFields(channelID) {
    cpassAxios({
      url: "/bot/get-agent-fields/" + channelID,
    }).then((response) => {
      if (response.status) {
        for (let field of response.data.data) {
          setColumns((prev) => ({
            ...prev,
            [channelID]: handleColumns(prev[channelID]),
          }));

          function handleColumns(val = []) {
            val.push({
              label: field.label,
              name: field.name,
              options: {
                customBodyRender: (value) => {
                  return value?.length > 40
                    ? value?.substring(0, 39) + "....."
                    : value;
                },
              },
            });
            return val;
          }
        }
      }
    });
  }
}
